"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var close_1 = __importDefault(require("material-ui/svg-icons/navigation/close"));
var check_1 = __importDefault(require("material-ui/svg-icons/navigation/check"));
var recompose_1 = require("recompose");
var Checker = function (_a) {
    var value = _a.value;
    return (value === true ? react_1.default.createElement(check_1.default, null) : react_1.default.createElement(close_1.default, null));
};
exports.default = recompose_1.compose(recompose_1.pure, recompose_1.defaultProps({ value: false }))(Checker);
//# sourceMappingURL=Checker.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/Checker.js
// module id = 2215
// module chunks = 0